import React from 'react';
import '../styles/spicedetail.css';
import { useParams } from 'react-router-dom';
import spices from '../data/data';
import { useTranslation } from 'react-i18next'; 

function SpicesDetail() {
  const { t } = useTranslation(); 
  const { id } = useParams();
  const spice = spices.find((item) => item.name === id);

  return (
    <div>
      <div className='bg' style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
      }}>
        <div className='container'>
          {spice ? (
            <div className="spice-detail">
              <div className="spice-image-container">
                <img src={spice.image} alt={t(spice.nameKey)} /> {/* Use translation key */}
              </div>
              <div className="spice-text-container">
                <h1>{t(spice.nameKey)}</h1> {/* Use translation key */}
                <p>{t('type')}: {t(spice.typeKey)}</p> {/* Use translation key */}
                {spice.originKey && <p>{t('origin')}: {t(spice.originKey)}</p>} {/* Conditionally display origin if available */}
                <p>{t(spice.descriptionKey)}</p> {/* Use translation key */}
                {spice.subDescriptionKey && <p>{t(spice.subDescriptionKey)}</p>}
              </div>
            </div>
          ) : (
            <p className="no-results">{t('no_spices_found')}</p> 
          )}
        </div>
      </div>
      <div className='footer'>
        <p className='foot-head'>{t('company_name_full')}</p>
        <p>No: 37/953, 24th Main, JP Nagar II Phase, Bangalore-560078</p>
        <p>{t('all_rights_reserved', { year: new Date().getFullYear() })}</p>
      </div>
    </div>
  );
}

export default SpicesDetail;